// https://css-tricks.com/building-progress-ring-quickly/
class ProgressRing extends HTMLElement {
    constructor() {
        super();
        this.stroke = Number(this.getAttribute('stroke')) || 0;
        this.radius = Number(this.getAttribute('radius')) || 0;
        this.progress = Number(this.getAttribute('progress')) || 0;

        this._root = this.attachShadow({mode: 'open'});
        this.render()
        window.addEventListener('resize', this.render.bind(this));
    }

    setProgress(percent) {
        // First, set this.progress so that it's set correctly next time this.render() is called
        this.progress = percent;
        const progressOffset = this._circumference - (this.progress / 100 * this._circumference);
        const circle = this._root.querySelector('circle.circle-progress');
        circle.style.strokeDashoffset = progressOffset;
    }

    static get observedAttributes() {
        return ['progress'];
    }

    attributeChangedCallback(name, oldValue, newValue) {
        if (name === 'progress') {
            this.setProgress(newValue);
        }
    }

    render() {
        const backgroundColor = this.hasAttribute('background-color')
            ? this.getAttribute('background-color')
            : 'white';
        const progressColor = this.hasAttribute('progress-color')
            ? this.getAttribute('progress-color')
            : 'white';

        const stroke = this.stroke;
        const radius = this.radius; // progress radius
        const diameter = radius * 2 + stroke + 4; // outer diameter

        this._circumference = radius * 2 * Math.PI; // progress circumference
        const progressOffset = this._circumference - (this.progress / 100 * this._circumference);


        this._root.innerHTML = `
<svg viewBox="0 0 ${diameter} ${diameter}">
    <circle
        class="circle-background"
        stroke="${backgroundColor}"
        stroke-width="2"
        fill="transparent"
        r="${radius + stroke / 2 + 1}"
        cx="${diameter / 2}"
        cy="${diameter / 2}"
    />
    <circle
        class="circle-background"
        stroke="${backgroundColor}"
        stroke-width="2"
        fill="transparent"
        r="${radius - stroke / 2 - 1}"
        cx="${diameter / 2}"
        cy="${diameter / 2}"
    />
    <circle
        class="circle-progress"
        stroke="${progressColor}"
        stroke-dasharray="${this._circumference} ${this._circumference}"
        style="stroke-dashoffset:${progressOffset}"
        stroke-width="${stroke + 1}"
        stroke-linecap="round"
        fill="transparent"
        r="${radius}"
        cx="${diameter / 2}"
        cy="${diameter / 2}"
    />
</svg>

<style>
    circle {
        transition: stroke-dashoffset 2s;
        transform: rotate(-90deg);
        transform-origin: 50% 50%;
    }
    .background {
        stroke-dasharray: ${this._circumference} !important;
        stroke-dashoffset: 0 !important;
    }

    svg {
        overflow: visible;
    }
</style>
    `;
    }
}

window.customElements.define('progress-ring', ProgressRing);
